var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-overlay',{attrs:{"show":false,"rounded":"sm","variant":"white"}},[_c('b-card',[_c('accommodations-ledger-accounts-table',{attrs:{"accommodations":_vm.mappedAccommodations,"loading":_vm.loading,"show-search":""}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }